"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Choice = _ref => {
  let {
    preselectedIndex,
    prefix,
    subtle,
    children,
    deselectable,
    className,
    onSelect,
    ...other
  } = _ref;
  const childrenArray = _react.Children.toArray(children);
  const [selectedItem, setSelectedItem] = (0, _react.useState)(childrenArray[preselectedIndex] && childrenArray[preselectedIndex].props.id);
  const onChoiceSelect = id => {
    const isSelected = selectedItem === id;
    const currentItem = isSelected && deselectable ? null : id;
    setSelectedItem(currentItem);
    return onSelect && onSelect(currentItem);
  };
  (0, _react.useEffect)(() => {
    setSelectedItem(childrenArray[preselectedIndex] && childrenArray[preselectedIndex].props.id);
  }, [preselectedIndex]);
  const baseClass = `${prefix}choice`;
  const listClasses = (0, _classnames.default)(baseClass, className);
  return _react.default.createElement("ul", _extends({
    className: listClasses
  }, other), childrenArray.map((child, i) => {
    const key = child.key || i;
    const isSelected = selectedItem === child.props.id;
    return _react.default.createElement("li", {
      key: key,
      className: `${baseClass}__list-item`
    }, (0, _react.cloneElement)(child, {
      selected: isSelected,
      onClick: function () {
        onChoiceSelect(...arguments);
        if (child.props.onClick) child.props.onClick(...arguments);
      },
      subtle
    }));
  }));
};
Choice.defaultProps = {
  prefix: ''
};
var _default = Choice;
exports.default = _default;